import { useEffect, useState } from "react";
import "../artikel/artikel.css";
import ArtikelItem from "./ArtikelItem";
import { getArtikel, getKategoriArtikel } from "./service";

const Artikel = () => {
  const [dataArtikel, setDataArtikel] = useState([]);
  const [kategoriArtikel, setKategoriArtikel] = useState([]);

  const fetchArticle = async () => {
    try {
      const data = await getArtikel()
      setDataArtikel(data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCategoryArticle = async () => {
    try {
      const data = await getKategoriArtikel()
      setKategoriArtikel(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchArticle();
    fetchCategoryArticle();
  }, []);

  return (
    <div>
      <section>
        <div className="container">
          <div className="list-artikel">
            <div className="row">
              <ArtikelItem
                data={dataArtikel}
                kategori_artikel={kategoriArtikel}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Artikel;
